// 应用全局配置

// ==================== 环境配置区 ====================
// 测试环境与线上环境的差异化配置（仅放置随环境变化的项，如网关地址、登录地址）
// 测试环境：本地 npm run dev 时使用（process.env.NODE_ENV === 'development'）
const devConfig = {
  // 后台网关地址（测试环境）
  baseUrl: 'http://localhost:8080',
  // 登录地址（测试环境）
  loginUrl: 'http://localhost:3002/login'
}

// 线上环境：npm run build 打包时使用（process.env.NODE_ENV === 'production'）
const prodConfig = {
  // 后台网关地址（线上环境）
  baseUrl: 'http://auth.xuekastart.cn',
  // 登录地址（线上环境）
  loginUrl: 'http://auth.xuekastart.cn/login'
}

// 根据构建/运行环境自动选择：开发态(测试运行)取 devConfig，生产态(打包)取 prodConfig
const envConfig = process.env.NODE_ENV === 'production' ? prodConfig : devConfig

// ==================== 公共配置区 ====================
// 与环境无关的公共配置，测试与线上保持一致
const config = {
  // 后台网关地址（按环境自动注入）
  baseUrl: envConfig.baseUrl,
  // 登录地址（按环境自动注入）
  loginUrl: envConfig.loginUrl,
  svapid: 'gh0540025',
  clientID: 'f876f5d495a91c919addf0bb1e7c0e0a',

  // 应用信息
  appInfo: {
    // 应用名称
    name: "知汇文化",
    // 应用版本
    version: "1.1.0",
    // 应用logo
    logo: "/static/logo.png",
    // 官方网站
    site_url: "",
    // 政策协议
    agreements: [{
        title: "隐私政策",
        url: ""
      },
      {
        title: "用户服务协议",
        url: ""
      }
    ]
  },
  /** 接口加密功能开关(如需关闭 后端也必须对应关闭) */
  appEncrypt: true,
  /** 接口加密传输 RSA 公钥与后端解密私钥对应 如更换需前后端一同更换 */
  rsaPublicKey: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKoR8mX0rGKLqzcWmOzbfj64K8ZIgOdHnzkXSOVOZbFu/TJhZ7rFAN+eaGkl3C4buccQd/EjEsj9ir7ijT7h96MCAwEAAQ==',
  /** 接口响应解密 RSA 私钥与后端加密公钥对应 如更换需前后端一同更换 */
  rsaPrivateKey: 'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAmc3CuPiGL/LcIIm7zryCEIbl1SPzBkr75E2VMtxegyZ1lYRD+7TZGAPkvIsBcaMs6Nsy0L78n2qh+lIZMpLH8wIDAQABAkEAk82Mhz0tlv6IVCyIcw/s3f0E+WLmtPFyR9/WtV3Y5aaejUkU60JpX4m5xNR2VaqOLTZAYjW8Wy0aXr3zYIhhQQIhAMfqR9oFdYw1J9SsNc+CrhugAvKTi0+BF6VoL6psWhvbAiEAxPPNTmrkmrXwdm/pQQu3UOQmc2vCZ5tiKpW10CgJi8kCIFGkL6utxw93Ncj4exE/gPLvKcT+1Emnoox+O9kRXss5AiAMtYLJDaLEzPrAWcZeeSgSIzbL+ecokmFKSDDcRske6QIgSMkHedwND1olF8vlKsJUGK3BcdtM8w4Xq7BpSBwsloE='
}

export default config



// WEBPACK FOOTER //
// ./src/config.js